import React from 'react';
import styled from 'styled-components';
import { fonts} from '../common/mixins.js';
import Button from '../common/Button.jsx';

const Container = styled.div`
    background-color:white;
    width:100%;
    padding:16px;
    border-radius:8px;
    display:flex;
    flex-direction:column;
    justify-content:space-between;
    gap:16px;
    border: 1px solid #EDF1F6;
`;

const Title = styled.div`
    ${fonts.normalTextSmallBold()};
`;

const FlexContainer = styled.div`
    width:100%;
    display:flex;
    flex-direction:column;
    gap:16px;
`;

const Small = styled.div`
    ${fonts.normalTextSmall()}; 
`;

const PayOnline = ({ requestKey }) => {

    const url = `https://www.more.com/pay/${requestKey}`;
    return (
        <Container>
            <FlexContainer id="payOnlineContainer">
                <Title>{orderdetails_resources.OnlinePayment}</Title>
                <Small>{orderdetails_resources.OnlinePaymentText}</Small>
            </FlexContainer>
            <Button type="primary" target="_self" text={orderdetails_resources.PayNow} url={url} height={"32px"}/>
       
        </Container>
    );
};

export default PayOnline;
